<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="" :bordered="false">
        <div class="title"><img src="../../assets/images/logo-mini.png" alt="足球财富" style="height: 44px;width: 44px;">内部料后台管理系统</div>
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
          <!--<p class="login-tip">输入任意用户名和密码即可</p>-->
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import { setCookie } from '../../libs/util'
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex'
export default {
  components: {
    LoginForm
  },
  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    handleSubmit (param) {
      let { login_name, password } = param
      this.$api.login({ login_name, password, keepLogin: true }).then(res => {
        if (res.code === 0) {
          this.$Message.success('登录成功')
          var getId = res.data.id
          setCookie('userId', getId)
          setCookie('login_name', login_name)
          localStorage.setItem('poster', res.data.poster)
          localStorage.setItem('sa', res.data.identity === 0 ? '1' : '0')
          if (res.data.identity === 0) {
            this.$router.push({
              name: 'author_manage'
            })
          } else {
            this.$router.push({
              name: 'order_manage'
            })
          }
        } else {
          this.$Message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>

</style>
